import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { buildInfo, buildKind } from '@/shared/buildInfo';

// One fetch per page load, shared by every mount. docs-api's public
// GET /version, on this origin (the proxy).
let apiInfoPromise = null;
const loadApiInfo = () => {
  if (!apiInfoPromise) {
    apiInfoPromise = fetch('/version', { cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null);
  }
  return apiInfoPromise;
};

/**
 * "docs v1.2.3 · api v1.2.3" line in the top bar's person menu. Both are
 * release names — the
 * frontend's from the pod (window.__RELEASE__), the backend's from its public
 * GET /version; the tooltip names the builds the bytes were made as.
 */
const VersionFooter = ({ className = '' }) => {
  const { t } = useTranslation(['sidebar']);
  const [api, setApi] = useState(undefined); // undefined = loading, null = unavailable

  useEffect(() => {
    let alive = true;
    loadApiInfo().then((info) => alive && setApi(info));
    return () => {
      alive = false;
    };
  }, []);

  const tier = api?.tier || (buildKind === 'release' ? null : buildKind);
  const apiLabel =
    api === undefined ? '…' : api ? `v${api.version}` : t('sidebar:buildInfo.unavailable');

  return (
    <div
      className={`px-1 text-[11px] leading-4 font-mono text-gray-400 dark:text-gray-500 truncate ${className}`}
      title={[
        `${buildInfo.service} ${buildInfo.version} (build ${buildInfo.build}, ${buildInfo.gitSha}, ${buildInfo.buildTime})`,
        api
          ? `${api.service} ${api.version} (build ${api.build ?? api.version}, ${api.git_sha}, ${api.build_time})`
          : null,
      ]
        .filter(Boolean)
        .join('\n')}
      data-testid="version-footer"
    >
      {t('sidebar:buildInfo.app')} v{buildInfo.version} · {t('sidebar:buildInfo.api')} {apiLabel}
      {tier ? ` · ${tier}` : ''}
    </div>
  );
};

export default VersionFooter;
